import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';
import { BASE_URL } from '../../../config';

const initialState = {
  error: null,
  time: null,
  data: [],
  stockBreakerData: [],
  stockHistory: [],
  addData: {},
  processStockBreaking: {},
  allStockStatus: [],
  availabilityReportData: [],
  qtyChangeAuditData: [],
  closingHistoryFiles: [],
  closingHistoryData: [],
  closingHistoryAccess: null,
  closingHistorySummary: {},
  closingHistoryPagination: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Stock',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET StockManagement
    getStocksSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET StockManagement
    getStockAvailabilityData(state, action) {
      state.availabilityReportData = action.payload.data;
    },
    getQtyChangeAuditData(state, action) {
      state.qtyChangeAuditData = action.payload.data;
    },
    getStockClosingHistoryFilesSuccess(state, action) {
      state.closingHistoryFiles = action.payload.data;
    },
    getStockClosingHistorySuccess(state, action) {
      state.closingHistoryData = [];
      state.closingHistoryAccess = action.payload;
      state.closingHistorySummary = action.payload.metadata || {};
      state.closingHistoryPagination = {};
    },
    clearStockClosingHistory(state) {
      state.closingHistoryData = [];
      state.closingHistoryAccess = null;
      state.closingHistorySummary = {};
      state.closingHistoryPagination = {};
    },

    // GET StockManagement
    getMisplaceStockSuccess(state, action) {
      state.misplaceData = action.payload.data;
    },

    // GET All Stock Status Success
    getAllStockStatusesSuccess(state, action) {
      state.getAllStockStatus = action.payload.data;
    },

    // GET StockManagement
    getStocksHistorySuccess(state, action) {
      state.stockHistory = action.payload.data;
    },

    addOrUpdateStocks(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    getStockBreakerSuccess(state, action) {
      state.stockBreakerData = action.payload.data;
    },

    updateStockBreakerSuccess(state, action) {
      state.processStockBreaking = action.payload.data;
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      state.checkout.activeStep = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAvailabilityData(date, locationId) {
  return async () => {
    try {
      const response = await get(`StockAvailability?date=${date}&locationId=${locationId}`);
      if (response.status) {
        dispatch(slice.actions.getStockAvailabilityData(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getStockBalancerAvailabilityData(date, locationId) {
  return async () => {
    try {
      const response = await get(`StockAvailability?date=${date}&locationId=${locationId}`);
      if (response.status) {
        dispatch(slice.actions.getStockAvailabilityData(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getQtyChangeAudit({ startDate, endDate, locationId, stockCode }) {
  return async () => {
    try {
      const response = await get(`stock/qty-change-audit`, { startDate, endDate, locationId, stockCode });
      if (response.status) {
        dispatch(slice.actions.getQtyChangeAuditData(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getStockClosingHistoryFiles({ fromDate, toDate, locationId }) {
  return async () => {
    try {
      const response = await get('stock/closing-history/files', { fromDate, toDate, locationId });
      if (response.status) {
        dispatch(slice.actions.getStockClosingHistoryFilesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStockClosingHistory({ businessDate }) {
  return async () => {
    try {
      const response = await get('stock/closing-history/file', { businessDate });
      if (response.status) {
        dispatch(slice.actions.getStockClosingHistorySuccess(response));
      } else {
        dispatch(slice.actions.clearStockClosingHistory());
        dispatch(slice.actions.hasError(response.message));
      }
      return response;
    } catch (error) {
      dispatch(slice.actions.clearStockClosingHistory());
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getStockClosingHistoryStreamUrl({ businessDate }) {
  const queryString = new URLSearchParams({ businessDate }).toString();
  return `${BASE_URL}stock/closing-history/stream?${queryString}`;
}

export function getStockClosingHistoryRequestInit() {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem('authToken')?.toString() || ''}` },
  };
}

export async function downloadStockClosingHistory({ businessDate }) {
  const queryString = new URLSearchParams({ businessDate }).toString();
  const response = await fetch(`${BASE_URL}stock/closing-history/download?${queryString}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('authToken')?.toString() || ''}` },
    method: 'GET',
  });

  if (!response.ok) {
    let message = 'Could not download stock closing history.';
    try {
      const data = await response.json();
      message = data?.message || message;
    } catch (error) {
      message = error?.message || message;
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `stock-closing-${businessDate}-all-locations.parquet`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
export function getStocks(location, limit, code, codeArray, getPosItems = false, includeEmptyStock = false) {
  return async () => {
    try {
      const response = await get(`Stock?location=${location}&limit=${limit}&code=${code}&codeArray=${codeArray}&getPosItems=${getPosItems}&includeEmptyStock=${includeEmptyStock}`);
      if (response.status) {
        dispatch(slice.actions.getStocksSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getMisplaceStockList() {
  return async () => {
    try {
      const response = await get(`getMisplacedStockData`);
      if (response.status) {
        dispatch(slice.actions.getMisplaceStockSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getAllStockStatus(location, limit, code) {
  return async () => {
    try {
      const response = await get(`get-all-stock-status`);
      if (response.status) {
        dispatch(slice.actions.getAllStockStatusesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStockHistory(code) {
  return async () => {
    try {
      const response = await get(`stock-history?code=${code}`);
      if (response.status) {
        dispatch(slice.actions.getStocksHistorySuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addStock(body) {
  return async () => {
    try {
      const response = await post(`Stock`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStocks(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFromBreakerDetails(id) {
  return async () => {
    try {
      const response = await get(`StockBreaker?id=${id}`);
      if (response.status) {
        dispatch(slice.actions.getStockBreakerSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function clearStockBreakerData() {
  return async () => {
    try {
      dispatch(slice.actions.getStockBreakerSuccess({}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateStockBreaking(body) {
  return async () => {
    try {
      const response = await put(`processStockBreaking`, body);
      if (response.status) {
        dispatch(slice.actions.updateStockBreakerSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function clearProcessStockBreaking() {
  return async () => {
    try {
      dispatch(slice.actions.updateStockBreakerSuccess({}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateStock(body) {
  return async () => {
    try {
      const response = await put(`Stock`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStocks(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function restoreWastedStock(body) {
  return async () => {
    try {
      const response = await put(`restoreWastedStock`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStocks(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------

export function approveMovedStock(body) {
  return async () => {
    try {
      const response = await put(`approveMovedStock`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStocks(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
